var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _vm.categories.length
        ? _c("category-header", {
            attrs: {
              title: _vm.resolveCategoryName(_vm.category),
              active: _vm.dropdownVisible,
              loading: _vm.loading
            },
            on: { click: _vm.onToggleBar }
          })
        : _c("ul", { staticClass: "item" }, [
            _c("li", [
              _c("label", { staticClass: "radio" }, [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.categoryIsSelected(_vm.category) },
                  on: {
                    change: function($event) {
                      return _vm.checkItem(_vm.category)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.resolveCategoryName(_vm.category)))
                ])
              ])
            ])
          ]),
      _vm._v(" "),
      _vm.dropdownVisible
        ? _c(
            "ul",
            { staticClass: "item-child" },
            [
              _vm._l(_vm.categories, function(category) {
                return [
                  _c("li", { staticClass: "level-2" }, [
                    _c("label", { staticClass: "radio" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.categoryIsSelected(category) },
                        on: {
                          change: function($event) {
                            return _vm.checkItem(category)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.resolveCategoryName(category)))
                      ])
                    ])
                  ])
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }